import gql from 'graphql-tag'

export const question = gql`
  fragment Question on SystemResponse {
    id
    messages {
      type
      text
      data
      dataLabels
      xLabel
      yLabel
      title
    }
    freetext
    answer_choices
    selected_answer
    multiselect
    singleline
    require_validation
    long_answers
    slider
  }
`

export const session = gql`
  fragment Session on SurveySession {
    id
    survey_id
    complete
    percent_complete
    results_redirect
    is_survey_setup
    languages
    system_responses {
      ...Question
    }
  }
  ${question}
`


// WEBPACK FOOTER //
// ./src/graphql/fragments.js